




























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentCampaignTabularActions
  from '@/modules/content-campaign/components/admin/AdminContentCampaignTabularActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'
import { AdminDepositRoute } from '@/modules/deposit/routes/admin-deposit.route'
import {
  DepositCollectionModelInAdmin,
  DepositCollectionWithModelInAdmin
} from '@/modules/deposit/models/deposit-collection.model'
import {
  adminDepositPayDialogTabularColumn
} from '@/modules/deposit/models/columns/admin-deposit-pay-dialog-tabular.column'
import DepositPayableTypeView from '@/modules/deposit/components/shared/DepositPayableTypeView.vue'
import BankAccountTypeView from '@/modules/bank-account/components/shared/BankAccountTypeView.vue'

@Component({
  components: {
    BankAccountTypeView,
    DepositPayableTypeView,
    MediaAttachmentDialog,
    TabularHeader,
    AdminCampaignStatus: CampaignStatusView,
    DateTooltipped,
    AdminContentCampaignTabularActions,
    TextEllipsis
  }
})
export default class AdminDepositPayOffDialogTabular extends Vue {
  constructor(
    private readonly route: AdminDepositRoute
  ) {
    super()
  }

  @Prop({ required: true }) deposit: DepositCollectionModelInAdmin
  @Prop({ required: true }) withData: DepositCollectionWithModelInAdmin
  private columnsData = adminDepositPayDialogTabularColumn()

  private get columns() {
    return this.filterColumns()
  }

  filterColumns() {
    return this.columnsData
  }

}
